<div class="flex flex-col space-y-4">
  <div class="flex flex-col items-start">
    <h1 class="font-semibold text-2xl">Comparison</h1>
    <span class="text-text-secondary/80">{{ selectedPeriodLabel() }}</span>
  </div>

  @switch (dataState().status) {
    @case ('loading') {
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
        @for (i of [1, 2, 3]; track i) {
          <app-loading-skeleton variant="chart" />
        }
      </div>
      <app-loading-skeleton variant="card" />
      <app-loading-skeleton variant="table" />
    }
    @case ('error') {
      <app-error-state title="Failed to load comparison data" [message]="error()!" (retry)="onRetry()" />
    }
    @case ('success') {
      @if (isEmpty()) {
        <app-empty-state message="There are no solutions to compare for this project." title="No comparison data" />
      } @else {
        <div animate.enter="content-enter" class="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <div class="col-span-1 rounded-lg border border-border p-4">
            <app-bar-chart
              title="Total cost ({{ charts().currencyUnit }})"
              [categories]="charts().categories"
              [series]="charts().totalCostSeries"
              [yUnit]="charts().currencyUnit" />
          </div>

          <div class="col-span-1 rounded-lg border border-border p-4">
            <app-bar-chart
              title="Total emissions ({{ charts().co2Unit }})"
              [categories]="charts().categories"
              [series]="charts().totalCo2Series"
              [yUnit]="charts().co2Unit" />
          </div>

          <div class="col-span-1 rounded-lg border border-border p-4">
            <app-bar-chart
              title="Total air pollutants ({{ charts().pollutantUnit }})"
              [categories]="charts().categories"
              [series]="charts().pollutantsSeries"
              [yUnit]="charts().pollutantUnit" />
          </div>
        </div>

        <app-recommendation [recommendation]="recommendation()" />
        <app-comparison-table [solutions]="solutions()" />
      }
    }
  }
</div>
